
export const environment = {
  production: false,
  env: "dev",
  
  baseUrl:  'https://b4life.codefab.it',
  // authUrl:   'https://b4life-auth-dev-g8bpc7fnfpace0dd.italynorth-01.azurewebsites.net/',
  authUrl:   'https://b4life-auth-dev.codefab.it',
  // apiUrl:  'https://b4life-api-dev-esf8hgg8bbakejgm.italynorth-01.azurewebsites.net',
  apiUrl:  'https://b4life-api-dev.codefab.it',
  mediaUrl: 'https://b4life-media.codefab.it', 
};

